import React from 'react';
import { Main } from './components';

export const ReusedList: React.FC = () => {
    return <Main />;
};

